module.exports = __webpack_public_path__ + "img/mayas_from.f575df34.png";